/* @ngInject */
function AnalyticsInsightsHomeController ($rootScope, $scope, $translate, $sce, $state, $window, AnalyticsService, SegmentService, ToastService, Utils) {
  const start = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString() // last 30 days
  const end = new Date().toISOString() // today

  $scope.flags = {
    maxInsights: 4,
    loading: false,
    card: {
      skeletonType: 'INSIGHTS_CARDS'
    },
    description: {
      skeletonType: 'INSIGHTS_HOME_DESCRIPTION'
    }
  }

  $scope.description = ''
  $scope.locale = ''

  $scope.cardItems = []

  const api = {
    _getUserLocale,
    _successGetUserLocale,
    _getInsightsHome,
    _successGetInsights,
    _errorGetInsights,
    _finallyGetInsights,
    _getDescription,
    _mountCardItems
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._getUserLocale()
  }

  $scope.openIntercomSurvey = () => {
    $window.open('https://app.deskfy.io/home?intercom_survey_id=35992097', '_blank')
    SegmentService.track('analytics-widget-feedback-click')
  }

  $scope.goToAnalyticsOverview = () => {
    $state.go('analytics.dashboard', {
      slug: 'overview'
    })

    SegmentService.track('analytics-widget-seemore-click')
  }

  function _getUserLocale () {
    $scope.flags.loading = true
    $rootScope.getUser().then(api._successGetUserLocale)
  }

  function _successGetUserLocale ({ locale }) {
    $scope.locale = locale
    $scope.description = $sce.trustAsHtml(api._getDescription(locale))

    api._getInsightsHome({
      start,
      end,
      maxInsights: $scope.flags.maxInsights
    })
  }

  function _getInsightsHome (params) {
    AnalyticsService.getInsights('home', params)
      .then(api._successGetInsights)
      .catch(api._errorGetInsights)
      .finally(api._finallyGetInsights)
  }

  function _successGetInsights (response) {
    if (!response.length) {
      $scope.cardItems = []
      $scope.noData = true
      return
    }

    $scope.cardItems = api._mountCardItems(response)
  }

  function _errorGetInsights (error) {
    console.log({ error })

    $scope.cardItems = []
    $scope.noData = true
    ToastService.defaultErrorToast()
  }

  function _finallyGetInsights () {
    $scope.flags.loading = false
  }

  function _getDescription (locale) {
    const dayOptions = {
      day: 'numeric',
      month: 'numeric'
    }

    const monthOptions = {
      month: 'long'
    }

    const month = Utils.capitalize(Utils.formatDate(end, locale, monthOptions))
    const startDay = Utils.formatDate(start, locale, dayOptions)
    const endDay = Utils.formatDate(end, locale, dayOptions)

    const description = $translate.instant('analyticsInsights.home.description', {
      month,
      startDay,
      endDay
    })

    return description
  }

  function _mountCardItems (response) {
    const maxCardsLength = 4

    if (response.length === maxCardsLength) {
      const lastIndex = response.length - 1
      const lastCard = response[lastIndex]

      const cardItems = response.map(card => {
        if (card.id === lastCard.id) {
          return {
            ...card,
            isLastCard: true
          }
        }

        return {
          ...card,
          isLastCard: false
        }
      })

      return cardItems
    }

    return response
  }
}

export { AnalyticsInsightsHomeController }
